import React from 'react';
import Loader from '../../components/loader';

const ProvisioningPage = () => <Loader dataHook="provisioning-loader" />;

export default ProvisioningPage;
